export default "__VITE_ASSET__DDwHieOu__"